module.exports = __webpack_public_path__ + "assets/img/21.8a983a43.png";